import i18n from "../i18n";

const resolveLanguage = (lang?: string): "fr" | "en" =>
  lang?.toLowerCase().startsWith("fr") ? "fr" : "en";

function formatDate(
  timestampInSeconds?: number,
  lang: "fr" | "en" = resolveLanguage(i18n.resolvedLanguage ?? i18n.language),
) {
  if (!timestampInSeconds) return "";
  const date = new Date(timestampInSeconds * 1000);
  const locale = lang === "fr" ? "fr-FR" : "en-GB";
  return date.toLocaleDateString(locale, {
    weekday: "long",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function normalizeText(text: string): string {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

function validateEmail(email: string) {
  return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i.test(email);
}

function extractApiErrorMessage(
  error: unknown,
  fallbackMessage: string,
): string {
  if (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    typeof (error as { response?: unknown }).response === "object"
  ) {
    const response = (error as { response?: { data?: unknown } }).response;
    const data = response?.data;
    if (
      typeof data === "object" &&
      data !== null &&
      "message" in data &&
      typeof (data as { message?: unknown }).message === "string"
    ) {
      return (data as { message: string }).message;
    }
  }

  return error instanceof Error ? error.message : fallbackMessage;
}

export { formatDate, normalizeText, validateEmail, extractApiErrorMessage };
